import { PaginatedResource } from '../../typings/Paginated';
import { BaseService, GenericPaginatedParameters, Unauthorized, UnexpectedError } from './base-service';

export class DocumentService extends BaseService {
    async getDocuments(params: GenericPaginatedParameters): Promise<PaginatedResource<DocumentFile>> {
        const token = await this.getToken();
        const res = await fetch(`${this.centralEndpoint}/documents${this.encodeQueryParams({ ...params })}`, {
            method: 'GET',
            headers: this.getHeaders(token, 'application/json;charset=utf-8'),
        });

        if (res.status == 401) {
            throw new Unauthorized();
        } else if (res.status != 200) {
            throw new UnexpectedError();
        }
        return res.json();
    }
}

export const documentService = new DocumentService();
